/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {StatisticheOrdiniDettagli2} from '../../../../_metronic/partials/widgets'

export function StatisticheOrdini2() {
  return (
    <>	
      <div className='row g-5 g-xl-8'>
      <div className='col-xl-12 col-lg-12 col-md-12 mb-5'>
      <StatisticheOrdiniDettagli2 className='card-xxl-stretch mb-5 mb-xl-10' color='success'/>
      </div>
    </div>
    </>
  )
}
